import React, { useState } from "react";
import "../../../assets/scss/account/register.scss";
import "../../../assets/scss/account/forgotPassword.scss";
import Spinner from "../../../@core/components/spinner/Fallback-spinner";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Swal from "sweetalert2";
import HeaderLogo from "../../../components/header/headerLogo";

import Repository from "../../../configs/axios/repository";
import marketingJpg from "../../../assets/images/account/login.svg";
import clear from "../../../assets/images/account/clear.png";

const ForgotPassword = () => {
    const [showEmailClear, setShowEmailClear] = useState(false);
    const [loadingData, setLoadingData] = useState(true);
    const [isresponseTrue, setIsresponseTrue] = useState(false);
    const [findUser, setfindUser] = useState(null);

    const sendEmail = async (values) => {
        setLoadingData(false);
        const result = await Repository.postRequest(
            `api/users/sendEmailForForgotPassword`,
            values
        );
        setLoadingData(true);
        if (result.data?.success === true) {
            //
            setIsresponseTrue(true);
        }
    };
    const handleClear = (formik, nameFild) => {
        if (nameFild == "user_name") {
            formik.setFieldValue("user_name", "");
        } else if (nameFild == "email") {
            formik.setFieldValue("email", "");
        }
    };
    const emailSearch = async (values) => {
        const result = await Repository.findByEndPoint(
            `api/users/findUserByEmail/${values}`
        );
        if (result.data.data == null) {
            setfindUser(false);
        } else {
            setfindUser(true);
        }
    };
    return loadingData ? (
        <div>
            <HeaderLogo />
            <div className="sectionParentDiv">
                <div className="registerContent ">
                    <div>
                        <div className="rounded mx-auto d-block forgootField">
                            <h1>Forgot Password</h1>
                            <p>
                                We will send you a link to this email to reset
                                your password.
                            </p>
                            {isresponseTrue ? (
                                <div>
                                    <p className="isResponseTrue">
                                        We have sent you a link to this email to
                                        reset your password.. Please check your
                                        inbox to reset your password.
                                    </p>
                                </div>
                            ) : (
                                <Formik
                                    initialValues={{
                                        email: "",
                                    }}
                                    validate={(values) => {
                                        const errors = {};

                                        if (values.email) {
                                            setShowEmailClear(true);
                                        }

                                        if (!values.email) {
                                            errors.email = "Email is required.";
                                        } else if (
                                            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                                                values.email
                                            )
                                        ) {
                                            errors.email =
                                                "Invalid email address";
                                        } else {
                                            emailSearch(values.email);
                                        }
                                        if (findUser == false) {
                                            errors.email =
                                                "This email was not found in our database";
                                        }

                                        if (!values.email) {
                                            setShowEmailClear(false);
                                            errors.email =
                                                "Email Address is required.";
                                        }

                                        return errors;
                                    }}
                                    onSubmit={(values, { setSubmitting }) => {
                                        sendEmail(values);
                                    }}
                                >
                                    {(formik) => (
                                        <Form className="formikForgot">
                                            <ErrorMessage
                                                className="errorMessage"
                                                name="email"
                                                component="div"
                                            />

                                            <div className="labelInputs">
                                                Email
                                            </div>

                                            <Field
                                                className="formikInputForgoot"
                                                type="email"
                                                name="email"
                                                placeholder="Email Address"
                                            />
                                            <div className="forgotViewIcon">
                                                {showEmailClear ? (
                                                    <img
                                                        onClick={() => {
                                                            handleClear(
                                                                formik,
                                                                "email"
                                                            );
                                                        }}
                                                        src={clear}
                                                        alt="clear"
                                                    />
                                                ) : (
                                                    ""
                                                )}
                                            </div>

                                            <div className="resetSubmit">
                                                <button type="submit">
                                                    Send Email
                                                </button>
                                            </div>
                                        </Form>
                                    )}
                                </Formik>
                            )}
                        </div>
                    </div>
                </div>
                <div className="marketingForgotDivJpg ">
                    <img src={marketingJpg} alt="marketingJpg" />
                </div>
            </div>
        </div>
    ) : (
        <Spinner spiner={true} />
    );
};

export default ForgotPassword;
